import React, { useState, useEffect } from 'react';
import {
    Table, TableBody, TableCell, TableContainer, TableRow, Paper,
    TableHead, TablePagination, TextField, Dialog,
    DialogActions, DialogContent, Box, DialogContentText, DialogTitle, Button, Typography, Link
} from '@mui/material';
import { useUser } from '../contexts/UserContext';
import Swal from 'sweetalert2';
import AddComentario from './AddComentario';
import { useAccesos } from '../contexts/AccesosContext';


function GestionComentario({idOportunidad = null}) {

        const server = process.env.REACT_APP_API_ROUTE;
        const key = process.env.REACT_APP_API_KEY;
        const [comentarios, setComentarios] = useState([]);
        const [editComentario, setEditComentario] = useState(null);
        const [searchQuery, setSearchQuery] = useState('');
        const [page, setPage] = useState(0);
        const [rowsPerPage, setRowsPerPage] = useState(5);
        const [openDialog, setOpenDialog] = useState(false);
        const [comentarioToDelete, setComentarioToDelete] = useState(null);
        const { user } = useUser();   
        const { tienePermiso } = useAccesos();

    // const navigate = useNavigate();

        const fetchComentarios = async () => {
                    try {
                        const response = await fetch(`${server}/CrmComentarios/poridOportunidad/${idOportunidad}`);
                        const data = await response.json();
                        setComentarios(data.$values);
                    } catch (error) {
                        console.error('Error al cargar los Comentarios:', error);
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'Error al cargar los Comentarios: ' + error,
                        });
                            }
                        };

            useEffect(() => {
                const fetchComentarios = async () => {
                    try {
                        let response;
                        if(idOportunidad) {
                            response = await fetch(`${server}/CrmComentarios/poridOportunidad/${idOportunidad}`);
                        } else {
                            response = await fetch(`${server}/CrmComentarios`);
                        }

                        const data = await response.json();
                        setComentarios(data.$values || []);
                    } catch (error) {
                        console.error('Error al cargar lps comentarios', error);
                        Swal.fire({
                            icon:'error',
                            title:'Error',
                            text: 'Error al cargar los comentarios: '+ error,
                        });
                    }

                };

                    fetchComentarios();
              
            }, [idOportunidad]);
        
            
            if (!idOportunidad) {
                    return (
                    <Typography variant="body1" color="textSecondary">
                        Selecciona una oportunidad para ver sus comentarios.
                    </Typography>
                );
            }

            const handleNewComentario = () => {
                if(idOportunidad) {
                    fetch(`${server}/CrmComentarios/poridOportunidad/${idOportunidad}`)
                    .then(res => res.json())
                    .then(data => setComentarios(data.$values || []))
                    .catch(console.error);
                }else{
                    fetch(`${server}/CrmComentarios`)
                    .then(res => res.json())
                    .then(data => setComentarios(data.$values || []))
                    .catch(console.error);
                }
                
                setEditComentario(null);
                fetchComentarios(idOportunidad);
            };
        
            const handleChangePage = (event, newPage) => {
                setPage(newPage);
            };
        
            const handleChangeRowsPerPage = (event) => {
                setRowsPerPage(parseInt(event.target.value, 10));
                setPage(0);
            };
        
            const handleSearchChange = (event) => {
                setSearchQuery(event.target.value);
            };
        
            const handleOpenDialog = (comentario) => {
                setComentarioToDelete(comentario);
                setOpenDialog(true);
            };
        
            const handleCloseDialog = () => {
                setOpenDialog(false);0
                setComentarioToDelete(null);
            };
        
            const handleDeleteComentario= async () => {
                if (comentarioToDelete) {
                    try {
                        const username = ''+user.codigoUsuario+'/';
        
                        const response = await fetch(`${server}/CrmComentarios/${comentarioToDelete.id}/${username}`,
                             {
                            method: 'DELETE'
                        });
                        if (response.ok) {
                            
                            handleCloseDialog();
                            await fetchComentarios();
                            Swal.fire({
                                icon: 'success',
                                title: 'Éxito',
                                text: 'Comentario eliminado con éxito',
                            });
                        } else {
                            handleCloseDialog();
        
                            const errorData = await response.json();
                            const errorMessage = errorData.message || (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                            Swal.fire({
                                icon: 'error',
                                title: `Error ${response.status}`,
                                text: errorMessage,
                            });
                        }
                    } catch (error) {
                        console.error('Error al eliminar el comentario:', error);
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'Error al eliminar el comentario: ' + error,
                        });            }
                }
            };
        
            const filteredComentario = comentarios.filter(comentario => comentario.comentario?.toLowerCase().includes(searchQuery.toLowerCase()));
    
        const handleCancelarEdicion = () => {
            setEditComentario(null);
        };

    return (
        <>
            <div className="x_content">
                <br />
                 <AddComentario handleNewComentario={handleNewComentario} editComentario={editComentario} idOportunidad={idOportunidad} cancelarEdicion={handleCancelarEdicion}/>
                <div className="ln_solid" />
                <h2>Comentarios</h2>

                <TableContainer component={Paper}>
                    <Table>
                        <TableBody>
                            {filteredComentario.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((comentario) => (
                                <TableRow key={comentario.id}>
                                    <TableCell align="right">
                                        <Button onClick={() => setEditComentario(comentario)} color="primary" disabled={!tienePermiso('Editar Comentario CRM')}>
                                            Editar
                                        </Button>
                                        <Button onClick={() => handleOpenDialog(comentario)} color="secondary" disabled={!tienePermiso('Eliminar Comentario CRM')}>
                                            Eliminar
                                        </Button>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='body1'>{comentario.comentario}</Typography>
                                        <Typography variant='caption' color="textSecondary">{comentario.ingresadoPor} - {new Date(comentario.fechaIngreso).toLocaleString()}</Typography>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>

                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={comentarios.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </TableContainer>
                <Dialog open={openDialog}
                                onClose={handleCloseDialog}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description">
                                <DialogTitle id="alert-dialog-title">{"Confirmar eliminación"}</DialogTitle>
                                <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    ¿Estás seguro de que quieres eliminar este comentario?
                                </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                <Button onClick={handleCloseDialog} color="primary">Cancelar</Button>
                                <Button onClick={handleDeleteComentario} color="primary" autoFocus>Eliminar</Button>
                                </DialogActions>
                            </Dialog>
            </div>
        </>
    );
}

export default GestionComentario;